<template>
    <v-sheet>
        <v-list dense>

            <v-list-item @click="tileClicked" v-if="clickable">
                <v-list-item-avatar>
                    <v-icon medium :color="iconColor">{{icon}}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <slot></slot>
                </v-list-item-content>
            </v-list-item>

            <v-list-item v-else>
                <v-list-item-avatar>
                    <v-icon medium :color="iconColor">{{icon}}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <slot></slot>
                </v-list-item-content>
            </v-list-item>

        </v-list>
    </v-sheet>
</template>

<script>

    export default {

        components: {},

        props: {
            icon: {
                type: String,
                required: false,
                default: null
            },

            iconColor: {
                type: String,
                required: false,
                default: null
            },

            clickable: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        methods: {
            tileClicked() {
                this.$emit('click');
            }
        }
    }
</script>

